import { createSelector } from '@reduxjs/toolkit';

import hasContestLesson from '@classCreation/utils/hasContestLesson';

const baseSelector = (state) => state.sbatGroupBulkUpdate;

export const selectedBulkUpdateSbatGroupsSelector = (state) =>
  baseSelector(state).selectedSbatGroups;

export const removeSuperBatchesModalStageSelector = (state) =>
  baseSelector(state).removeSuperBatchesModalStage;

export const sbatGroupBulkUpdateCommunicationsSelector = (state) =>
  baseSelector(state).communications;

export const addSuperBatchesModalStateSelector = (state) =>
  baseSelector(state).addSuperBatchesModalState;

export const updateInstructorsModalStateSelector = (state) =>
  baseSelector(state).updateInstructorsModalState;

export const deleteSbatGroupsModalStageSelector = (state) =>
  baseSelector(state).deleteSbatGroupsModalStage;

export const sbatGroupBulkUpdateReasonSelector = (state) =>
  baseSelector(state).reason;

export const bulkDeleteErrorMessageSelector = (state) =>
  baseSelector(state).bulkDeleteErrorMessage;

export const selectedBulkUpdateContestSbatGroupsSelector = createSelector(
  (state) => baseSelector(state).selectedSbatGroups,
  (selectedSbatGroups) => {
    return Object.values(selectedSbatGroups).reduce(
      (contestSbatGroups, sbatGroup) => {
        const isContest = hasContestLesson(sbatGroup.academy_topic.lessons);

        if (isContest) {
          contestSbatGroups.push(sbatGroup.id);
        }

        return contestSbatGroups;
      },
      []
    );
  }
);
